import * as Sentry from "@sentry/react";

// Gate Session Replay behind cookie consent (GDPR) — the user must opt in before
// we record anything. Errors and tracing still flow (essential for reliability).
const _consent = (() => {
  try { return localStorage.getItem('ludy_cookie_consent'); } catch { return null; }
})();
const _replayAllowed = _consent === 'accepted';

Sentry.init({
  dsn: "https://dac6ac73dae4d7b2d317e66e6dc5bf9a@o4511306077896705.ingest.de.sentry.io/4511306085040208",
  sendDefaultPii: false,
  tracesSampleRate: 1.0,
  replaysOnErrorSampleRate: _replayAllowed ? 1.0 : 0,
  replaysSessionSampleRate: _replayAllowed ? 0.1 : 0,
  environment: process.env.NODE_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
});

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
